import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import AdaptacionesCurriculares from "../../components/Form/Fields/AdaptacionesCurriculares";
import CantidadEstudiantes from "../../components/Form/Fields/CantidadEstudiantes";
import CaracteristicasEspacio from "../../components/Form/Fields/CaracteristicasEspacio";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import DuracionActividad from "../../components/Form/Fields/DuracionActividad";
import Edad from "../../components/Form/Fields/Edad";
import ObjetivosEspecificos from "../../components/Form/Fields/ObjetivosEspecificos";
import TemaClase from "../../components/Form/Fields/TemaClase";
import LudicaYJuegosCardImg from "../../components/UmmIApps/Cards/LudicaYJuegosCardImg.png";
import GetObjetivosAprendizaje from "../../components/ObjetivosAprendizaje/GetObjetivosAprendizaje";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";

const LudicaYJuegosPage = () => {
  const {
    nivelId,
    materiaId,
    handleBack,
    promptData,
    toggleCamposAvanzados,
    mostrarCamposAvanzados,
    isOAAdded,
    setTextoInicial,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    handleInitialPromptData,
  } = useActividadesContext();

  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled = !(
    promptData.nivel &&
    promptData.materia &&
    promptData.tema &&
    promptData.edad &&
    promptData.cantidad_estudiantes &&
    promptData.duracion &&
    isOAAdded
  );
  const colorIconBack = "#BA4534";

  useEffect(() => {
    const init = {
      nivel: "",
      materia: "",
      objetivos: [],
      caracterizacion: "",
      tema: "",
      condiciones_contexto: "",
      adaptaciones_curriculares: "",
      edad: 4,
      cantidad_estudiantes: 1,
      duracion: 5,
      objetivos_especificos: "",
      caracteristicas_espacio: "",
    };
    handleInitialPromptData(init, "aprendizaje_ludica");
    setTextoInicial(
      "Esta es la propuesta que tengo para ti. Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={LudicaYJuegosCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #E3B5AE 100%, #C86A5D 100%)"
        }
        titleColor="#BA4534"
        title="Actividades lúdicas y juegos"
        description="Crea juegos y actividades interactivas que motiven a tus alumnos a explorar y reforzar conocimientos"
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid item xs={12} lg={12} display="flex" flexDirection="row">
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mr: 2, mb: 4 }}>
            <GetNiveles
              onNivelChange={handleNivelChange}
              selectedNivel={nivelId}
            />
          </Grid>

          {/* Nuevo componente para consultar y probar el endpoint de asignaturas */}
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mb: 4 }}>
            <GetAsignaturas
              nivelId={nivelId}
              onAsignaturaChange={handleAsignaturaChangeLocal}
              selectedAsignatura={materiaId}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <GetObjetivosAprendizaje
            nombreAsignatura={promptData.materia}
            nombreNivel={promptData.nivel}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ mb: 3 }}>
          <TemaClase />
        </Grid>
        <Grid item xs={12}>
          <Edad />
        </Grid>
        <Grid item xs={12}>
          <DuracionActividad />
        </Grid>
        <Grid item xs={12}>
          <CantidadEstudiantes />
        </Grid>

        <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
          <Button
            variant="text"
            sx={{ color: "#336B87" }}
            onClick={toggleCamposAvanzados}
            endIcon={
              mostrarCamposAvanzados ? <ExpandMoreIcon /> : <ExpandMoreIcon />
            }
          >
            {mostrarCamposAvanzados
              ? "Ocultar opciones avanzadas"
              : "Mostrar opciones avanzadas (opcional)"}
          </Button>
        </Grid>
        {/* Campos avanzados */}
        {mostrarCamposAvanzados && (
          <>
            <Grid item xs={12}>
              <ObjetivosEspecificos />
            </Grid>
            <Grid item xs={12}>
              <CaracteristicasEspacio />
            </Grid>
            <Grid item xs={12}>
              <CondicionesContexto />
            </Grid>
            <Grid item xs={12}>
              <Caracterizacion />
            </Grid>
            <Grid item xs={12}>
              <AdaptacionesCurriculares />
            </Grid>
          </>
        )}
      </UmmiaAppsLayout>
    </>
  );
};

export default LudicaYJuegosPage;
